//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rule',
  props: {},
  data () {
    return {
      rulelist: [
        {
          question: 'Q1：哪些用户有资格参加集邮票活动？',
          answer: 'A1：中国邮政集团工会浙江省委员会下属各基层工会会员'
        },
        {
          question: 'Q2：邮票可以兑换什么礼物？',
          answer: 'A2：邮票可直接兑换积分、抢兑好礼，也可以参与抽奖等<br/>请注意：兑换实物礼物前，请先填写默认收货地址，填写路径：个人中心 - 收货地址 - 编辑默认地址<br/>第二类：邮票抢兑（不定期开展）<br/>活动期间，用户可以消耗邮票参与一轮兑换，抢兑10点30分开始、16点30分结束。礼品不定期刷新，数量有限，先到先得。<br/>第三类：邮票抽奖（不定期开展）<br/>活动期间，用户随时可以消耗邮票参与抽奖，礼品不定期刷新，大奖数量有限，先到先得。'
        },
        {
          question: 'Q3：怎么可以获得邮票？',
          answer: 'A3：每日参与不同活动，根据活动的难易程度可获得不同的邮票；活动中抽奖，也有机会获得邮票。'
        },
        {
          question: 'Q4：本期的邮票何时会清零？',
          answer: 'A4：当月得到的邮票，次月当天23：59：59过期清零。（比如：1月1日得到的邮票2月1日23：59：59到期）'
        },
        {
          question: 'Q5：邮票获得、兑换记录在哪里可以查询到？',
          answer: 'A5：邮票的收支明细可点击活动页面顶部的“明细”按钮进行查询'
        },
        {
          question: 'Q6：使用邮票兑换的积分何时到期？',
          answer: 'A6：积分暂不限制使用时间，后续变动将发布通告'
        },
        {
          question: 'Q7：还有什么其他注意事项？',
          answer: 'A7：本次活动中所涉及的达标统计时间、礼品兑换时间均以北京时间为准；用户不得任何舞弊、不正当手段参与本活动，一旦发现，本平台有权采取邮票清零等措施，亦有权收回用户已领取的邮票及礼品，并保存追究对该用户责任的权利。如因此带给用户造成损失，本平台不进行任何赔偿或补偿。舞弊及不正当手段包括但不限于：篡改设备数据；使用任何模拟器、插件、外挂、机器人软件、刷屏软件等非法工具恶意刷取邮票或活动礼品；恶意牟利、扰乱平台秩序；使用插件、外挂、系统或第三方工具对活动进行干扰、破坏、修改或施加其他影响及本平台认为的其他不正当手段。'
        }
      ]
    }
  },
  created () { },
  mounted () { },
  methods: {
  }
}
